import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import * as styles from "../Footer.module.scss";

const ColumnSection = ({ keyId, renderLinks, columnData }) => (
	<div key={keyId} className={cx(styles.footer__section, styles.tab)}>
		<input type="checkbox" id={columnData.id} />
		<label htmlFor={columnData.id} className={cx(styles.footer__section__title, styles.tab__label)}>
			{columnData.title}
			<span className={styles.tab__label__chevron} />
		</label>
		<div className={styles.tab__content}>
			<ul>
				{columnData.links?.map(item => (
					<li key={item.id}>{renderLinks(item, styles.footer__links)}</li>
				))}
			</ul>
		</div>
	</div>
);

ColumnSection.propTypes = {
	renderLinks: PropTypes.func.isRequired,
	keyId: PropTypes.string.isRequired,
	columnData: PropTypes.shape({
		id: PropTypes.string,
		title: PropTypes.string,
		links: PropTypes.arrayOf(
			PropTypes.shape({
				id: PropTypes.string,
				title: PropTypes.string,
				url: PropTypes.string,
			})
		),
	}).isRequired,
};

export default ColumnSection;
export { ColumnSection };
